import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "input-wrapper" };
const _hoisted_2 = { class: "input-wrapper" };
const _hoisted_3 = { class: "input-wrapper" };
const _hoisted_4 = { class: "input-wrapper" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_autocomplete = _resolveComponent("v-autocomplete");
    const _component_v_text_field = _resolveComponent("v-text-field");
    const _component_InputRow = _resolveComponent("InputRow");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_InputRow, {
            label: _ctx.localeInfo.feeRate.label
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_autocomplete, {
                        "item-title": "text",
                        "item-value": "value",
                        modelValue: _ctx.feeRateComputed,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.feeRateComputed) = $event)),
                        items: _ctx.feeRateOptionList,
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        onKeyup: _cache[1] || (_cache[1] = ($event) => ($event.stopPropagation())),
                        onBlur: _cache[2] || (_cache[2] = ($event) => (_ctx.handleBlurFeeRateField(_ctx.formData.feeRate)))
                    }, null, 8 /* PROPS */, ["modelValue", "items"]),
                    _cache[12] || (_cache[12] = _createElementVNode("span", { class: "mx-1" }, ":", -1 /* CACHED */)),
                    _createVNode(_component_v_text_field, {
                        value: _ctx.agencyFeeRateComputed,
                        variant: "outlined",
                        disabled: "",
                        filled: "",
                        "hide-details": "auto"
                    }, null, 8 /* PROPS */, ["value"])
                ])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.localeInfo.workerFeeRate.label
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_v_autocomplete, {
                        "item-title": "text",
                        "item-value": "value",
                        modelValue: _ctx.workerFeeRateComputed,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.workerFeeRateComputed) = $event)),
                        items: _ctx.feeRateOptionList,
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        onKeyup: _cache[4] || (_cache[4] = ($event) => ($event.stopPropagation())),
                        onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.handleBlurWorkerFeeRateField(_ctx.formData.workerFeeRate)))
                    }, null, 8 /* PROPS */, ["modelValue", "items"]),
                    _cache[13] || (_cache[13] = _createElementVNode("span", { class: "mx-1" }, ":", -1 /* CACHED */)),
                    _createVNode(_component_v_text_field, {
                        value: _ctx.agencyWorkerFeeRateComputed,
                        variant: "outlined",
                        disabled: "",
                        filled: "",
                        "hide-details": "auto"
                    }, null, 8 /* PROPS */, ["value"])
                ])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.localeInfo.storeFeeRate.label
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_v_autocomplete, {
                        "item-title": "text",
                        "item-value": "value",
                        modelValue: _ctx.storeFeeRateComputed,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.storeFeeRateComputed) = $event)),
                        items: _ctx.feeRateOptionList,
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        onKeyup: _cache[7] || (_cache[7] = ($event) => ($event.stopPropagation())),
                        onBlur: _cache[8] || (_cache[8] = ($event) => (_ctx.handleBlurStoreFeeRateField(_ctx.formData.storeFeeRate)))
                    }, null, 8 /* PROPS */, ["modelValue", "items"]),
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "mx-1" }, ":", -1 /* CACHED */)),
                    _createVNode(_component_v_text_field, {
                        value: _ctx.agencyStoreFeeRateComputed,
                        variant: "outlined",
                        disabled: "",
                        filled: "",
                        "hide-details": "auto"
                    }, null, 8 /* PROPS */, ["value"])
                ])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.localeInfo.storeManagementFeeRate.label
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_v_autocomplete, {
                        "item-title": "text",
                        "item-value": "value",
                        modelValue: _ctx.storeManagementFeeRateComputed,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.storeManagementFeeRateComputed) = $event)),
                        items: _ctx.feeRateOptionList,
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        onKeyup: _cache[10] || (_cache[10] = ($event) => ($event.stopPropagation())),
                        onBlur: _cache[11] || (_cache[11] = ($event) => (_ctx.handleBlurStoreManagementFeeRateField(_ctx.formData.storeManagementFeeRate)))
                    }, null, 8 /* PROPS */, ["modelValue", "items"]),
                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "mx-1" }, ":", -1 /* CACHED */)),
                    _createVNode(_component_v_text_field, {
                        value: _ctx.agencyStoreManagementFeeRateComputed,
                        variant: "outlined",
                        disabled: "",
                        filled: "",
                        "hide-details": "auto"
                    }, null, 8 /* PROPS */, ["value"])
                ])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"])
    ]));
}
